import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/fuse-template/core/navigation/navigation.service';
import { Navigation } from 'app/fuse-template/core/navigation/navigation.types';
import { formatPhoneNumber } from 'app/helpers/formatPhoneNumber';
import { formatSsn } from 'app/helpers/formatSsn';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { ReadUserRes } from 'app/interfaces/responses/Read/readUserRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { LSRNavigationService } from 'app/services/api/lsrnavigation/lsrnavigation.service';
import { LoaderService } from 'app/services/system/loader/loader.service';
import { USER_ROLES } from 'common/constants/user-role.constants';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'futuristic-layout',
    templateUrl: './futuristic.component.html',
    styleUrls: ['./futuristic.component.scss'],
})
export class FuturisticLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    fuseNavigation: Navigation;
    userDetails: ExposedReadUserDetailsRes;
    user: ReadUserRes;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    navigation: FuseNavigationItem[] = [];
    navigationActiveId: string;
    showSolustillingar: boolean;
    closeAnotherUserActiveRequest: boolean;

    userRoles = USER_ROLES;

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        public lsrauthService: LsrauthService,
        public lsrNavigationService: LSRNavigationService,
        public loaderService: LoaderService,
        public dialog: MatDialog
    ) {
        this.lsrauthService.userDetails.pipe(takeUntil(this._unsubscribeAll)).subscribe((userDetails) => {
            this.userDetails = userDetails;
        });
        this.lsrNavigationService.navigation.subscribe((navigation) => (this.navigation = navigation));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    formatSsn(ssn) {
        return formatSsn(ssn);
    }

    formatPhoneNumer(numer) {
        return formatPhoneNumber(numer);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$.pipe(takeUntil(this._unsubscribeAll)).subscribe((navigation: Navigation) => {
            this.fuseNavigation = navigation;
        });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$.pipe(takeUntil(this._unsubscribeAll)).subscribe(({ matchingAliases }) => {
            // Check if the screen is small
            this.isScreenSmall = !matchingAliases.includes('md');
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/utskra']);
    }
}
